import { FormHelperText, IconButton, styled } from "@mui/material";
import { Box } from "@mui/system";
import { useTheme } from "@mui/material/styles";
import React, { useState, useEffect, useRef } from "react";
import { useUpload } from "../../hooks/useUpload";
import { FormLabel } from "../../atoms";
import { InputFileUploadIcon } from "../../icons";
export type RenderUploadControlProps = {
  onClick: () => void;
  files?: string | string[];
};
export interface FileUploaderProps {
  multiple?: boolean;
  renderControl: (control: RenderUploadControlProps) => React.ReactNode;
  accept?: string;
  onChange?: (files?: string | string[]) => void;
}
export const Input = styled("input")({
  display: "none",
});

export const FileUploader = ({ multiple = false, renderControl, accept = "image/*", onChange = () => {} }: FileUploaderProps) => {
  const { mutate: upload } = useUpload();
  const [files, setFiles] = useState<string | string[]>();
  const inputRef = useRef<HTMLInputElement>(null);
  const handleOnChange = (e) => {
    const fileList = e.target.files;
    if (!fileList) return;
    const formData = new FormData();
    for (let index = 0; index < fileList.length; index++) {
      formData.append(`file-${index}`, fileList[index]);
    }
    upload(formData, {
      onSuccess: (dict: any) => {
        var newValues: string[] = [];
        for (var key in dict) {
          newValues.push(dict[key]);
        }
        const f = multiple ? newValues : newValues[0];
        setFiles(f);
        onChange(f);
      },
    });
  };
  const handleClick = () => {
    inputRef.current?.click();
  };
  return (
    <>
      <Input ref={inputRef} multiple={multiple} accept={accept} id="icon-button-file" type="file" onChange={handleOnChange} />
      {renderControl({ onClick: handleClick, files })}
    </>
  );
};
export type FileUploadControlProps = {
  value?: string | string[];
  placeholder?: string;
  helperText?: string;
  label: string;
  onClick?: () => void;
  files?: string | string[];
  onChange?: (values: string[] | string | undefined) => void;
};
export const FileUploadInput = ({ value, onChange = () => {}, files, placeholder = "Browse Files", onClick, label, helperText }: FileUploadControlProps) => {
  const [title, setTitle] = useState(placeholder);
  const theme = useTheme();
  const error = !!helperText;

  useEffect(() => {
    let title = placeholder;

    if (value) {
      let values = Array.isArray(value) ? value : [value];
      title = `${values.length} file(s) `;
    }
    setTitle((prev) => title);
  }, [value]);
  useEffect(() => {
    onChange(files);
  }, [files]);
  return (
    <div style={{ width: "100%" }}>
      <FormLabel error={error} label={label} />
      <IconButton
        sx={{
          textAlign: "right",
          px: "1.25rem",
          mt: "0.625rem",
          borderRadius: "0.75rem",
          height: "2.8125rem",
          fontSize: "1rem",
          ...(error && {
            "&.MuiButtonBase-root.MuiIconButton-root": {
              borderColor: "error.main",
            },
          }),
          color: "text.default",
          width: "100%",
          border: "0.0625rem solid rgba(255, 255, 255, 0.3)",
          justifyContent: "flex-start",
        }}
        component="span"
        onClick={onClick}
      >
        <InputFileUploadIcon htmlColor={theme.palette.success.main} style={{ marginRight: "0.625rem" }} /> {title}
      </IconButton>
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </div>
  );
};

export default FileUploader;
